import React from 'react';

export const LegalRepresentatives = () => {
  return <div></div>;
};
